import { useSelector } from 'react-redux';

/**
 * Client diagnoses + diagnosis matching, frontend side.
 *
 * DUPLICATED from @therapylake/package (client/diagnosis/diagnosis.constants.ts) — the client build
 * does not emit `@therapylake/package/types`, so these cannot be imported. Keep them in sync.
 */
export const DiagnosisMatchStatus = {
    MATCH: 'MATCH',
    MISMATCH: 'MISMATCH',
    NO_CODES: 'NO_CODES',
};

export const ClientDiagnosisStatus = {
    ACTIVE: 'ACTIVE',
    UPCOMING: 'UPCOMING',
    INACTIVE: 'INACTIVE',
};

export const clientDiagnosisStatusLabels = {
    [ClientDiagnosisStatus.ACTIVE]: 'Active',
    [ClientDiagnosisStatus.UPCOMING]: 'Upcoming',
    [ClientDiagnosisStatus.INACTIVE]: 'Inactive',
};

/** ICD-10 shape, dot optional (`F84.0`, `F840`, `S72.001A`). Mirrors ICD10_CM_CODE_PATTERN. */
export const ICD10_CM_CODE_PATTERN = /^[A-Z][0-9][0-9A-Z](\.?[0-9A-Z]{1,4})?$/;

/** Longest ICD-10-CM code with its dot (`S72.001A`). Mirrors MAX_DIAGNOSIS_CODE_LENGTH. */
export const MAX_DIAGNOSIS_CODE_LENGTH = 8;

export const MAX_DIAGNOSIS_DESCRIPTION_LENGTH = 250;

/** `f840` → `F84.0`. Mirrors formatDiagnosisCode. */
export const formatDiagnosisCode = (code) => {
    const key = (code ?? '').toUpperCase().replace(/[\s.]/g, '');
    return key.length > 3 ? `${key.slice(0, 3)}.${key.slice(3)}` : key;
};

/** Org-settings switch, carried on the company payload (`GET /company/profile`). */
export const useDiagnosisMatchEnabled = () => useSelector((state) => !!state.system.company?.diagnosisMatchEnabled);
